
const notificationContainer: { [key: string]: any } = {
    position: "fixed",
    width: "328px",
    top: "10px",
    background: "lightgray",
    borderRadius: "5px 0px 0px 5px",
    zIndex: 9999999999,
    height: "65px",
    right: 0,
    display: "flex",
    paddingLeft: "15px"
}

const notificationLeft = {
    display: "flex",
    flex: 2,
    borderRight: "2px solid #c4bfbf",
    alignItems: "center"
}

const notificationRight: { [key: string]: any } = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    fontFamily: "BrandonTextWeb-Bold",
    fontSize: "11px",
    color: "#ff316d",
    textAlign: "center"
}
const notificationActionTop = {
    borderBottom: "2px solid #c4bfbf",
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer"

}

const successText = {
    fontSize: 14,
    margin: "0 12px",
    fontFamily: "BrandonTextWeb-Medium"
}

export {
    notificationContainer,
    notificationLeft,
    notificationRight,
    successText,
    notificationActionTop
}